<script>
import IconNote from '@/components/icon/IconNote.vue';
import constants from '@/constants';

export default {
    computed: {
        constants() {
            return constants;
        },
        showTestEmails() {
            return this.$store.getters.IS_TEST_EMAILS_AVAILABLE;
        },
    },
    components: {
        ButtonIcon: IconNote,
    },
};
</script>

<template>
    <router-link
        v-if="showTestEmails"
        class="left_button_main_container"
        :to="{ name: constants.ROUTER_NAME.TESTEMAILS }"
    >
        <div class="left_button_icon_container">
            <ButtonIcon iconWidth="16px" iconHeight="16px" />
        </div>
        <div class="left_button_label_container">
            <label class="cursor_pointer">Test Emails</label>
        </div>
    </router-link>
</template>
